import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import TimelineSection from "../../components/apropos/TimelineSection";
import ValeursSection from "../../components/apropos/ValeursSection";
import Temoignages from "../../components/apropos/Temoignages";
import CardsStickyParallax from "../../components/apropos/entreprises";
import Header from "../../components/appLayout/header";
import SEO from "../../components/SEO";
import "./index.scss";
export const AproposPage = () => {
  const { t } = useTranslation();
  
  return (
    <div>
      <SEO
        title="À propos de MSIT Conseil - Notre Histoire et Nos Valeurs"
        description="Découvrez l'histoire de MSIT Conseil, nos valeurs, notre écosystème et notre vision de la transformation digitale. Une société de conseil experte en innovation technologique."
        keywords="à propos MSIT, histoire MSIT, valeurs MSIT, écosystème MSIT, transformation digitale"
        url="https://www.msit-conseil.fr/apropos"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "À propos", url: "https://www.msit-conseil.fr/apropos" }
        ]}
      />
      <TimelineSection />
      <ValeursSection />
      {/* <Temoignages /> */}
      <section className="ecosystem-section">
        <Container>
          <div className="ecosystem-content">
            <h2 className="ecosystem-title">
              {t("ecosystem.title")}
              <br />
              {t("ecosystem.title2")}
            </h2>
            <p className="ecosystem-text">
              {t("ecosystem.text")}
            </p>
          </div>
        </Container>
      </section>
      <CardsStickyParallax />
    </div>
  );
};
